import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const LANGUAGE_STRINGS = {
  en: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "SharedI18nStrings.languageNames.en"
  }),
  es: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "SharedI18nStrings.languageNames.es"
  }),
  ja: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "SharedI18nStrings.languageNames.ja"
  }),
  fr: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "SharedI18nStrings.languageNames.fr"
  }),
  de: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "SharedI18nStrings.languageNames.de"
  }),
  pt: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "SharedI18nStrings.languageNames.pt"
  })
};